<app-breadcrumb [master]="'Sprzedaż'" [parentName]="'Lista importów'" [name]="'Lista polis'"></app-breadcrumb>
<div class="sold-policy-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="sold-policy-list-filters">
    <app-dict-insurance-companies [multiple]="true" label="TU" class="sold-policy-list-filter" ngModel name="insuranceCompany"></app-dict-insurance-companies>

    <mat-form-field class="sold-policy-list-filter">
      <mat-label>Numer polisy</mat-label>
      <input matInput placeholder="Numer polisy" name="contains$policyNumber" ngModel>
    </mat-form-field>

    <app-dict [multiple]="false" label="Firma" class="sold-policy-list-filter" ngModel name="company" dictType="company"></app-dict>

    <app-dict-ofwcas [multiple]="false" label="OFWCA" class="sold-policy-list-filter" ngModel name="ofwca"></app-dict-ofwcas>

    <app-dict-partners [multiple]="false" label="Partner" class="sold-policy-list-filter" ngModel name="partner"></app-dict-partners>

    <mat-form-field class="sold-policy-list-filter">
      <mat-label>Przypis od</mat-label>
      <input matInput placeholder="Przypis od" name="gte$writtenPremium" ngModel>
    </mat-form-field>

    <mat-form-field class="sold-policy-list-filter">
      <mat-label>Przypis do</mat-label>
      <input matInput placeholder="Przypis do" name="lte$writtenPremium" ngModel>
    </mat-form-field>

    <app-datepicker
      class="sold-policy-list-filter"
      label="Data zawarcia od"
      placeholder="2000-01-01"
      [required]="false"
      ngModel name="gte$concludeDate"
    ></app-datepicker>

    <app-datepicker
      class="sold-policy-list-filter"
      label="Data zawarcia do"
      placeholder="2000-01-01"
      [required]="false"
      ngModel name="lte$concludeDate"
    ></app-datepicker>

    <app-dict-regionals [multiple]="true" label="Regionalny (majątek)" class="sold-policy-list-filter" ngModel name="assetsRegional"></app-dict-regionals>

  </form>

  <div class="sold-policy-list-buttons">
    <button  *ngIf="(userPermissions | async).registration.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).registration.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

  <table mat-table [dataSource]="imports">
    <ng-container matColumnDef="insuranceCompany">
      <th mat-header-cell *matHeaderCellDef> TU </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.insuranceCompany" class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">
          {{element.insuranceCompany.name}}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="policyNumber">
      <th mat-header-cell *matHeaderCellDef> Numer polisy </th>
      <td mat-cell *matCellDef="let element">
        {{element.policyNumber}}
      </td>
    </ng-container>

    <ng-container matColumnDef="writtenPremium">
      <th mat-header-cell *matHeaderCellDef> Przypis </th>
      <td mat-cell *matCellDef="let element" style="text-align: right">
        {{element.writtenPremium  | number:'1.2-2'}} zł
      </td>
    </ng-container>

    <ng-container matColumnDef="concludeDate">
      <th mat-header-cell *matHeaderCellDef> Data zawarcia </th>
      <td mat-cell *matCellDef="let element">
        {{element.concludeDate  | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef> OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.ofwca" class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca.uuid]">{{element.ofwca.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Partner </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element?.partner" class="default-link"
           [routerLink]="['/partnerzy/szczegoly', element?.partner?.uuid]">{{element?.partner?.shortName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="assetsRegional">
      <th mat-header-cell *matHeaderCellDef> Regionalny (majątek) OFWCA</th>
      <td mat-cell *matCellDef="let element">
        {{element.assetsRegional?.fullName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="contract">
      <th mat-header-cell *matHeaderCellDef> Umowa </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element.contract" class="default-link" [routerLink]="['/umowy/szczegoly', element.contract?.uuid]">{{element.contract?.number}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
